import { render, staticRenderFns } from "./SessionParcoursNavItemsDesktop.vue?vue&type=template&id=1065f04f&scoped=true&"
import script from "./SessionParcoursNavItemsDesktop.vue?vue&type=script&lang=js&"
export * from "./SessionParcoursNavItemsDesktop.vue?vue&type=script&lang=js&"
import style0 from "./SessionParcoursNavItemsDesktop.vue?vue&type=style&index=0&id=1065f04f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1065f04f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbarItems})
